// Types for the View Requisition V2 worklist (api/ViewRequisition/*V2, Page, Count, ...)

export type FilterType =
  | "text"
  | "prefix"
  | "exact"
  | "dropdown"
  | "multiselect"
  | "daterange"
  | "datepicker"
  | "timerange";

// One column from TabColumnsV2 (ViewRequisitionColumnsResponse), normalised.
export interface ColumnConfig {
  id: number;
  label: string;
  // ColumnKey — also what the API expects in SortColumn.
  key: string;
  columnName?: string;
  columnValue?: string;
  // FilterColumns (DB column the legacy filter targets) and the raw FilterColumnsType.
  filterColumns?: string;
  filterColumnsType?: string;
  filterType?: FilterType;
  fieldName?: string;
  isShow: boolean;
  isShowOnUi: boolean;
  isExpand: boolean;
  isEditable: boolean;
  // Raw JsonOptionData string (dropdown/multiselect). May be empty: load lazily with FilterOptions.
  optionsJson?: string | null;
}

export interface TabConfig {
  tabId: number;
  tabName: string;
  sortOrder: number;
  columns: ColumnConfig[];
}

// Matches WorklistFilter on the server. Only id + one value shape is required;
// columnName / columnType / filterValue are the legacy (v1) fields, sent for compatibility.
export interface WorklistFilter {
  id: number;
  value?: string;
  values?: string[];
  from?: string; // yyyy-MM-dd or HH:mm
  to?: string;
  columnName?: string;
  columnType?: string;
  filterValue?: string;
}

// Body of POST Page / Count / ExportCsv.
export interface WorklistRequest {
  tabId: number;
  pageSize?: number;
  cursor?: string | null;
  pageNumber?: number;
  sortColumn?: string | null;
  sortDirection?: "asc" | "desc";
  filters: WorklistFilter[];
}

export type Row = Record<string, unknown>;

export interface PageResult {
  rows: Row[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface CountResult {
  total: number;
  isCapped: boolean;
}

export interface Option {
  label: string;
  value: string;
}

export interface SortState {
  key: string;
  dir: "asc" | "desc";
}

// ------------------------------------------------------------ portal actions (v1 endpoints)

// StatusChangedV2 status ids (same as the v1 bulk action menu).
export enum StatusAction {
  Hold = 2,
  Complete = 3,
  Reject = 4,
  Delete = 5,
}

export interface StatusChangeRequest {
  statusId: StatusAction;
  RequisitionOrderIds: number[];
  ActionReasons: string;
  rejectComment?: string;
}

export interface ActionItem {
  key: string;
  label: string;
  icon?: string;
  danger?: boolean;
  permission?: string;
  onClick: () => void;
}
